import { AUTO_SELECTED_AREA_IDS } from "../constants/areas";

const getDescendents = (allAreas, area) => {
  const descendents = [];

  const getChildren = parent => {
    allAreas.forEach(a => {
      if (a.parent_id === parent.id) {
        descendents.push(a);
        getChildren(a);
      }
    });
  };

  getChildren(area);
  return descendents.map(descendent => descendent.id);
};

const getAscendents = (allAreas, area) => {
  const ascendents = [];

  const getParents = child => {
    allAreas.forEach(a => {
      if (child.parent_id === a.id && a.id !== 1) {
        ascendents.push(a);
        getParents(a);
      }
    });
  };

  getParents(area);
  return ascendents.map(ascendent => ascendent.id);
};

export const calculateCheckedAreas = (
  allAreas,
  area,
  allowAutoSelecting = true
) => {
  let ids;

  if (area.id === 1) {
    ids = [];
  } else {
    ids = [area.id, ...getDescendents(allAreas, area)];

    if (allowAutoSelecting && AUTO_SELECTED_AREA_IDS[area.id]) {
      ids.push(AUTO_SELECTED_AREA_IDS[area.id]);
    }
  }

  return ids;
};

export const calculateUncheckedAreas = (
  checkedAreas,
  area,
  allowAutoSelecting = true
) => {
  let ids;

  if (area.id === 1) {
    ids = [];
  } else {
    ids = [
      area.id,
      ...getAscendents(checkedAreas, area),
      ...getDescendents(checkedAreas, area)
    ];

    if (
      allowAutoSelecting &&
      AUTO_SELECTED_AREA_IDS[area.id] &&
      checkedAreas.find(({ id }) => id === AUTO_SELECTED_AREA_IDS[area.id])
    ) {
      ids.push(AUTO_SELECTED_AREA_IDS[area.id]);
    }
  }

  return ids;
};
